import QuestionService from '../services/QuestionService';
import { defaultErrorHandler } from './';
import { find, last, propEq } from 'ramda';

const initialState = {
  selectedQuestionId: -1,
  // questions are stored in the following format:
  // {
  //   [questionId]: { ..., pollId: 1 },
  //   [questionId]: { ..., pollId: 3 },
  // }
  questions: [],
  // we store the full question instead of a questionId because this question is used
  // on the home page, where we didn't fetch the questions yet
  activeQuestion: {},
  dedicated: false
};

export default {
  state: {
    // we need to clone the initialState because
    // on mutations the state is mutated
    ...initialState
  },

  getters: {
    selectedQuestion(state) {
      return find(propEq('questionId', state.selectedQuestionId))(state.questions) || {};
    },

    // we return an array of questions of the selectedPoll
    questionsOfSelectedPoll(state, getters, rootState) {
      return state.questions.filter(question => {
        return question.pollId === rootState.poll.selectedPollId;
      });
    },

    activeQuestion: state => state.activeQuestion,

    isDedicated: state => state.dedicated,

    isLastQuestion: state => {
      const question = last(state.questions);
      return question && question.questionId === state.selectedQuestionId;
    }
  },

  mutations: {
    ADD_QUESTIONS(state, questions) {
      state.questions = questions;
    },

    SELECT_QUESTION(state, questionId) {
      state.selectedQuestionId = questionId;
    },

    SET_ACTIVE_QUESTION(state, question) {
      state.activeQuestion = question;
    },

    SET_DEDICATED(state, value) {
      state.dedicated = !!value;
    }
  },

  actions: {
    addQuestions({ commit }, questions) {
      commit('ADD_QUESTIONS', questions);
    },

    unselectQuestion({ commit }) {
      commit('SELECT_QUESTION', initialState.selectedQuestionId);
    },

    selectQuestion({ commit }, questionId) {
      commit('SELECT_QUESTION', questionId);
    },

    // this is the active question on sync polls
    setActiveQuestion({ commit }, activeQuestion) {
      commit('SET_ACTIVE_QUESTION', activeQuestion);
    },

    voteQuestion({ dispatch }, { pollId, questionId, answersIds }) {
      QuestionService.vote(pollId, questionId, answersIds)
        .then(() => {
          return dispatch('saveUserVote', {
            pollId,
            questionId
          });
        })
        .catch(defaultErrorHandler);
    },

    setDedicated({ commit }, value) {
      commit('SET_DEDICATED', value);
    }
  }
};
